<template>
	<div id="preset-transforms-mismatch-modal" class="modal-new hidden">
		<span class="title">ACES Input or Output Transform mismatch</span>
		<p class="description text-left">
            ACES Input or Output transforms in the selected Preset do not match the currently selected ones. Which transform would you like to use?
		</p>
		<div class="buttons-continer">
			<button type="button" class="modal-btn --primary px-20" data-modal-action="keep-transforms">Keep current</button>
			<button type="button" class="modal-btn --cancel px-20" data-modal-action="replace-transforms">Load from preset</button>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style></style>
